import { render, staticRenderFns } from "./HorizontalProductCard.vue?vue&type=template&id=68921253&"
import script from "./HorizontalProductCard.vue?vue&type=script&lang=js&"
export * from "./HorizontalProductCard.vue?vue&type=script&lang=js&"
import style0 from "./HorizontalProductCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports